// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {useRefreshAllNodes} from '@wandb/weave/react';
import * as React from 'react';
import {useContext, useState} from 'react';
import {useHistory} from 'react-router-dom';

import {envIsPublicCloud} from '../../../config';
import {DEFAULT_ONPREM_ORGANIZATION_NAME} from '../../../pages/OrgDashboard/OrgRoles/RolesDashboard';
import {useIsProjectReadOnly} from '../../Registries/common/hooks';
import {
  checkRegistryProject,
  resolveRegistryUrl,
} from '../../Registries/common/utils';
import {AccountSelectorContext} from '../../Search/SearchNav/AccountSelectorContextProvider';
import {DeleteMembershipModal} from '../artifactMembership/PanelArtifactMembershipOverview/DeleteMembershipModal';
import * as S from './ArtifactMembershipActions.styles';

type ArtifactMembershipActionsProps = {
  isPortfolio: boolean;
  versionIndex: number;
  versionId: string;
  collectionId: string;
  collectionName: string;
  projectName: string;
  entityName: string;
  hasAliases: boolean;
  hasMemberships: boolean;
  onViewDetails: (versionIndex: number) => void;
};
export const ArtifactMembershipActions = ({
  isPortfolio,
  versionIndex,
  versionId,
  collectionId,
  collectionName,
  projectName,
  entityName,
  hasAliases,
  hasMemberships,
  onViewDetails,
}: ArtifactMembershipActionsProps) => {
  const {selectedAccount} = useContext(AccountSelectorContext);
  const accountOrgName = envIsPublicCloud
    ? (selectedAccount?.name ?? '')
    : DEFAULT_ONPREM_ORGANIZATION_NAME;
  const {isProjectReadOnly: readOnly} = useIsProjectReadOnly(
    entityName,
    projectName
  );
  const [isDeleteMembershipModalOpen, setDeleteMembershipModalOpen] =
    useState(false);
  const history = useHistory();
  const refreshAll = useRefreshAllNodes();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {registryName, isRegistryProject} = checkRegistryProject(projectName);

  return (
    <S.Buttons>
      <DropdownMenu.Root open={isMenuOpen} onOpenChange={setIsMenuOpen}>
        <DropdownMenu.Trigger>
          <Button
            size="small"
            variant="ghost"
            icon="overflow-horizontal"
            active={isMenuOpen}
          />
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content align="end">
            <DropdownMenu.Group>
              <DropdownMenu.Item onClick={() => onViewDetails(versionIndex)}>
                <Icon name="model" />
                View version details
              </DropdownMenu.Item>
            </DropdownMenu.Group>
            {!readOnly && (
              <>
                <DropdownMenu.Separator />
                <DropdownMenu.Item
                  onClick={() => setDeleteMembershipModalOpen(true)}>
                  <Icon name="delete" />
                  {`${isPortfolio ? 'Unlink version' : 'Delete version'}`}
                </DropdownMenu.Item>
              </>
            )}
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
      {isDeleteMembershipModalOpen && (
        <DeleteMembershipModal
          open={isDeleteMembershipModalOpen}
          setIsOpen={setDeleteMembershipModalOpen}
          onClose={() => setDeleteMembershipModalOpen(false)}
          isPortfolio={isPortfolio}
          artifactName={collectionName}
          versionIndex={versionIndex}
          afterDelete={async () => {
            const url = resolveRegistryUrl(
              isRegistryProject,
              accountOrgName,
              registryName ?? 'model'
            );
            await refreshAll();
            history.replace(url);
          }}
          artifactId={collectionId}
          artifactVersionId={versionId}
        />
      )}
    </S.Buttons>
  );
};
